import { GeocoderResult } from './types';

let GeocoderService: google.maps.Geocoder | null = null;

const getGeocoderService = () => {
  if (typeof window === 'undefined') {
    throw new Error('google.maps.places.AutocompleteService cannot be used on server side');
  }

  if (!window.google) {
    throw new Error('window.google is not defined');
  }

  if (!GeocoderService) {
    GeocoderService = new google.maps.Geocoder();
  }

  return GeocoderService;
};

const geocode = (request: google.maps.GeocoderRequest) => {
  const Service = getGeocoderService();

  return new Promise<GeocoderResult[]>((resolve, reject) => {
    void Service.geocode(request, (results, status) => {
      if (status === google.maps.GeocoderStatus.ZERO_RESULTS) {
        resolve([]);
      } else if (status !== google.maps.GeocoderStatus.OK || !results) {
        reject(new Error(status));
      } else {
        resolve(results);
      }
    });
  });
};

const GoogleGeocoder = {
  geocode,
};

export default GoogleGeocoder;
